/* eslint-disable max-len */
/* eslint-disable indent */
export default class HandleFormToggle {
    constructor() {
        this.toggle = document.getElementById('step_one_cropChoices');
        this.inputElements = document.querySelectorAll('[data-cultivation-select] > input[type=radio]');
        this.selectContainer = document.querySelectorAll('.js--select-holder');
        this.initState();
        this._setDOMReferences();
    }

    _setDOMReferences() {
        for (let i = 0; i < this.inputElements.length; i++) {
            this.inputElements[i].addEventListener('click', () => {
                this.removeActiveState();
                if (this.inputElements[i].checked) {
                    this.toggle.setAttribute('data-cultivation-select', this.inputElements[i].value);
                    if (this.toggle.dataset.cultivationSelect == this.selectContainer[i].getAttribute('data-cultivation')) {
                        this.selectContainer[i].classList.add('active');
                    }
                    console.log(this.toggle.dataset.cultivationSelect);
                }
            });
        }


    }
    removeActiveState() {
        for (let i = 0; i < this.selectContainer.length; i++) {
            this.selectContainer[i].classList.remove('active');
        }
    }
    /**
     * Set the first element on active before the user clicks
     */
    initState () {
        if (this.inputElements !== null && this.inputElements.length > 0) {
            this.inputElements[0].checked = true;
            this.selectContainer[0].classList.add('active');
        }
    }
}
